import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PersonIcon from "@mui/icons-material/Person";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ForkLeftIcon from "@mui/icons-material/ForkLeft";
import { useAppDispatch, useAppSelector } from "../../../framework/customStore";
import {
    setIsWorkShiftView,
    setSelectedVehicleId,
    setSelectedEmployeeId,
    setSelectedWorkShiftTimeSlotId,
    setSelectedWorkShift,
    setIsVehicleDetailView,
    resetTripDateRangeToToday
} from "../../../store/monitorViewSlice";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MonitorViewFleetSummaryTotals } from "../../../models/monitorView/monitorViewTypes";

interface SidebarHeaderProps {
    header: string;
    fleetSummaryTotals: MonitorViewFleetSummaryTotals;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({
    header,
    fleetSummaryTotals,
}) => {
    const dispatch = useAppDispatch();

    const {
        selectedWorkShift,
        isWorkShiftView,
        isVehicleDetailView } = useAppSelector((state) => state.monitorView);

    const effectiveDate = selectedWorkShift?.effectiveDate;
    const employeeId = selectedWorkShift?.employeeId;

    const closeWorkShiftView = () => {
        dispatch(setIsWorkShiftView(false));
        dispatch(setSelectedWorkShift(null));
        dispatch(setSelectedWorkShiftTimeSlotId(null));
        dispatch(setSelectedEmployeeId(null));
    };

    const closeVehicleDetailView = () => {
        dispatch(setIsVehicleDetailView(false));
        dispatch(setSelectedVehicleId(null));
        dispatch(resetTripDateRangeToToday());
    };

    return (
        <>
            {(isWorkShiftView || isVehicleDetailView) ? (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                    {isWorkShiftView ? (
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                            <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, justifyContent: "flex-start" }}>
                                <ArrowBackIcon
                                    onClick={closeWorkShiftView}
                                />
                            </Box>
                            <Tabs value={0} sx={{ flexGrow: 0 }}>
                                <Tab label={header} icon={<PersonIcon sx={{ color: "#FFFFFF" }} />} />
                            </Tabs>
                            <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, justifyContent: "flex-end" }}>
                                {effectiveDate ? (
                                    <a
                                        href={`/worktimepage/details/${employeeId}/${effectiveDate}/hourbooking`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <OpenInNewIcon fontSize="small" color="primary" />
                                    </a>
                                ) : null}
                            </Box>
                        </Box>
                    ) : (
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                            <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, justifyContent: "flex-start" }}>
                                <ArrowBackIcon
                                    onClick={closeVehicleDetailView}
                                />
                            </Box>
                            <Tabs value={0} sx={{ flexGrow: 0 }}>
                                <Tab label={header} icon={<ForkLeftIcon sx={{ color: "#FFFFFF" }} />} />
                            </Tabs>
                            <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, justifyContent: "flex-end" }}>
                                {/* Placeholder for future content, like additional icons or actions */}
                            </Box>
                        </Box>
                    )
                    }
                </Box>
            ) : (
                <SidebarOverviewHeader fleetSummaryTotals={fleetSummaryTotals} />
            )
            }
        </>
    );
};

interface SidebarOverviewHeaderProps {
    fleetSummaryTotals: MonitorViewFleetSummaryTotals
}

export const SidebarOverviewHeader = ({
    fleetSummaryTotals
}: SidebarOverviewHeaderProps) => {

    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                padding: "4px",
            }}
        >
            <Typography
                sx={{
                    color: "#fff",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                }}
            >
                {t("monitorView.sidebar.overview.header.title")}
            </Typography>
        </Box>
    );
};

export default SidebarHeader;